module.exports = __webpack_public_path__ + "static/media/title_sub_animation.9f9fa83b.png";